import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fleetoperate-failure-unsubscribe-email',
  templateUrl: './failure-unsubscribe-email.component.html',
  styleUrls: ['./failure-unsubscribe-email.component.scss']
})
export class FailureUnsubscribeEmailComponent implements OnInit {

  copyrightYear = 2020;
  linkedInURL: string = "https://linkedin.com/company/fleetoperate";
  facebookURL: string = "https://www.facebook.com/FleetOperate/";
  twitterURL: string = "https://twitter.com/fleetoperate";
  contactEmail: string = "help@fleetoperate.com";
  
  constructor() { }

  ngOnInit() {
  }

}
